import { render, staticRenderFns } from "./GroupSidebarForm.vue?vue&type=template&id=355488ca&scoped=true&"
import script from "./GroupSidebarForm.vue?vue&type=script&lang=js&"
export * from "./GroupSidebarForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupSidebarForm.vue?vue&type=style&index=0&id=355488ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355488ca",
  null
  
)

export default component.exports